<template>
    <div class="contact-form row q-col-gutter-x-lg">
        <div class="col-12 q-pb-lg">
            <q-input
                v-model="name"
                type="text"
                outlined
                clearable
                counter
                maxlength="150"
                :label="$t('general.name')"
                :error-message="nameErrors"
                :error="nameErrors != ''"
                @input="$v.name.$touch()"
                @blur="$v.name.$touch()"
            />
        </div>
        <div class="col-12 col-md-6 q-pb-lg">
            <q-input
                v-model="email"
                type="email"
                outlined
                clearable
                counter
                maxlength="150"
                :label="$t('general.email')"
                :error-message="emailErrors"
                :error="emailErrors != ''"
                @input="$v.email.$touch()"
                @blur="$v.email.$touch()"
            />
        </div>
        <div class="col-12 col-md-6 q-pb-lg">
            <q-input
                v-model="phone"
                type="tel"
                outlined
                clearable
                counter
                maxlength="25"
                :label="$t('general.phone')"
            />
        </div>
        <div class="col-12 q-pb-lg">
            <q-input
                :value="JSONParseTranslations(subjectAux, locale.key)"
                type="text"
                outlined
                clearable
                counter
                maxlength="100"
                :label="$t('general.subject')"
                :error-message="subjectErrors"
                :error="subjectErrors != ''"
                @input="$v.subjectAux.$touch()"
                @blur="$v.subjectAux.$touch()"
            />
        </div>
        <div class="col-12 q-pb-lg">
            <q-input
                v-model="messageAux"
                type="textarea"
                outlined
                clearable
                counter
                maxlength="1000"
                :label="$t('general.message')"
                :error-message="messageErrors"
                :error="messageErrors != ''"
                @input="$v.messageAux.$touch()"
                @blur="$v.messageAux.$touch()"
            />
        </div>
        <div
            class="col row"
            :class="{ 'justify-between': cancel, 'justify-end': !cancel }"
        >
            <q-btn
                v-if="cancel"
                flat
                :label="$t('actions.cancel')"
                @click="toggleDialog"
            />
            <q-btn
                color="secondary"
                :class="{ 'full-width': !cancel }"
                :label="$t('actions.send')"
                :disable="isSendingForm"
                @click="sendForm"
            />
        </div>
    </div>
</template>

<script>
import validations from '@/views/contact/mixins/validations'
import sendMailService from '@/services/emails'
import store from '@/store'
import translate from '@/local-shared/mixins/translate'

const loadingKeys = {
    sendingForm: 'sending-form',
}

export default {
    name: 'ContactForm',

    mixins: [validations, translate],

    props: {
        user: {
            type: Object,
            default: () => {},
        },

        subject: {
            type: String,
            default: '',
        },

        message: {
            type: String,
            default: '',
        },

        cancel: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            userId: '',
            name: '',
            email: '',
            phone: '',
            subjectAux: this.subject,
            messageAux: this.message,
        }
    },

    computed: {
        isSendingForm() {
            return this.sendingForm
        },

        sendingForm() {
            return !!this.loadings.filter(
                (loading) => loading.key === loadingKeys.sendingForm
            ).length
        },

        locale() {
            return store.getters['locale/currentLocale']
        },
    },

    mounted() {
        this.isUser()
    },

    methods: {
        isUser() {
            if (this.user) {
                if (this.user.id) {
                    this.userId = this.user.id
                }
                if (this.user.first_name) {
                    this.name = this.user.first_name
                }
                if (this.user.email) {
                    this.email = this.user.email
                }
                if (this.user.phone) {
                    this.phone = this.user.phone
                }
            }
        },

        async sendForm() {
            this.$v.$touch()

            if (this.$v.$invalid || this.isSendingForm) {
                return true
            }

            this.loadingAdd(loadingKeys.sendingForm)

            let parameters = {
                name: this.name,
                email: this.email,
                subject: this.subjectAux,
                message: this.messageAux,
                id: this.userId,
                phone: this.phone,
            }

            let response = await sendMailService.requestInformation(parameters)

            if (response.status === 200) {
                this.$q.notify({
                    type: 'positive',
                    message: this.$t('notify.email_message_sent'),
                })
                this.toggleDialog()
            } else {
                this.$q.notify({
                    type: 'negative',
                    message: this.$t('notify.email_error_message_not_sent'),
                })
            }
            this.loadingRemove(loadingKeys.sendingForm)
        },

        toggleDialog() {
            this.$emit('toggle-dialog')
        },
    },
}
</script>
